import * as React from "react";
import app_logo from "../../assets/app_logo.png";

export const Logo = () => {
  return <img className="App-logo" src={app_logo} alt="Application Logo" />;
};
